export default () => {
    return {
        open: false,
        total: 0,
        label: _t('kd.global.add_guest', 'Add guests'),
        init: function() {
            this.setTotal()

            this.$watch('open', (newValue) => {
                if (newValue == false) this.$store.search.houseKeeping()
            });

            // Changed via search/store to enforce housekeeping
            this.$watch('$store.search.activeSection', (newValue) => {
                if (newValue == 'allocation') this.open = true
            })
        },
        increase(type) {
            if (this.$store.search.allocation[type].value < this.$store.search.allocation[type].max_value) {
                this.$store.search.allocation[type].value++;
            }

            // if child is increased, add default age of 0 to avoid issues if the user doesn't select a different age
            if (type == 'child') {
                this.$store.search.allocation.child_ages.value[this.$store.search.allocation.child.value - 1] = 0
            }

            this.setTotal()
        },
        decrease(type) {
            if (this.$store.search.allocation[type].value > this.$store.search.allocation[type].min_value) {
                this.$store.search.allocation[type].value--;
                this.setTotal()
            }

            // check if type is adult or child and make sure room is not greater than total (future use case for room allocation)
            if (type == 'adult' || type == 'child') {
                if (this.$store.search.allocation.room.value > this.$store.search.total) {
                    this.$store.search.allocation.room.value = this.$store.search.total
                }
            }

            // if child is decreased, remove the last child age
            if (type == 'child') {
                this.$store.search.allocation.child_ages.value.pop()
            }
        },
        toggle() {
            if (this.open) return this.close()

            this.$refs.button.focus()
            this.open = true

            // scroll search form into view on mobile, on home page
            if (window.tg.is_mobile_device && window.tg.page_name === "homepage.index") document.getElementById('search-form-container').scrollIntoView({block: 'start', inline: 'nearest', behavior: 'smooth'});
        },
        close(focusAfter) {
            if (!this.open) return

            this.open = false

            focusAfter && focusAfter.focus()
        },
        setTotal() {
            let total = 0;

            for (let type in this.$store.search.allocation) {
                if (this.$store.search.allocation[type].value > 0 && this.$store.search.allocation[type].increase_total) {
                    total += this.$store.search.allocation[type].value;
                }
            }

            this.total = total

            const adult_allocation = this.$store.search.allocation['adult'].value
            const adults = _p('user.adults_cap', '%1$s Adult', '%1$s Adults', adult_allocation)
            const child_allocation = this.$store.search.allocation['child'].value
            const children = _p('user.children_cap', '%1$s Child', '%1$s Children', this.$store.search.allocation['child'].value, child_allocation)

            this.label = (child_allocation > 0) ? adults + ', ' + children : adults

            this.$store.search.total = total
            this.$store.search.total_label = this.label

            // update room max value to total - cannot have more rooms than guests
            this.$store.search.allocation.room.max_value = total
        }
    }
}
